import containerFuild from '../html-snippets/container-fuild.js';
import css from '../tpl-css/style-section-cefloreco-text-gradient.js';

const html = `
<div
  data-use-custom-width="true"
  data-custom-width="1204"
  class="container"
  data-attribute="container-content"
  style="--custom-width: 1204px;"
>
  <div class="wrap-content-section">
    <h2
      data-attribute="title-gradient"
      class="title-gradient"
      data-from-color="#fff"
      data-to-color="#333"
      style="--from-color:#fff; --to-color: #333"
    >
      130M+
    </h2>
    <div data-attribute="description">Monthly Active Users</div>
  </div>
</div>
`;

export default containerFuild(html, css, {
  backgroundColor: '#000',
  textColor: '#fff',
  topPadding: true,
  bottomPadding: true,
});
